// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var selectedBorderClass = "border-[#FF4D00]";

var defaultBorderClass = "border-stroke-subtle";

function syncSelectedBorder(element) {
  var checkbox = element.querySelector("input[type=\"checkbox\"]");
  if (!(checkbox == null)) {
    if (checkbox.checked) {
      DomEl$GameDataCore.removeClass(element, defaultBorderClass);
      return DomEl$GameDataCore.addClass(element, selectedBorderClass);
    } else {
      DomEl$GameDataCore.removeClass(element, selectedBorderClass);
      return DomEl$GameDataCore.addClass(element, defaultBorderClass);
    }
  }
  
}

function mounted() {
  var self = this ;
  var element = self.el;
  self.itemId = DomEl$GameDataCore.data(element, "item-id");
  self.openEvent = DomEl$GameDataCore.data(element, "open-event");
  self.toggleEvent = DomEl$GameDataCore.data(element, "toggle-event");
  self.clickTimer = undefined;
  self.lastClickTime = 0;
  var onClick = function ($$event) {
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var match = target.closest("input[type=\"checkbox\"]");
    if (!(match == null)) {
      return ;
    }
    var match$1 = target.closest("button[id$=\"-sr-open\"]");
    if (!(match$1 == null)) {
      return ;
    }
    $$event.preventDefault();
    var now = Date.now();
    var elapsed = now - self.lastClickTime | 0;
    var timer = self.clickTimer;
    if (timer !== undefined && elapsed < 300) {
      clearTimeout(Caml_option.valFromOption(timer));
      self.clickTimer = undefined;
      self.lastClickTime = 0;
      var id = Belt_Int.fromString(self.itemId);
      if (id !== undefined) {
        self.pushEvent(self.toggleEvent, {
              id: id
            });
      }
      return syncSelectedBorder(element);
    }
    self.lastClickTime = now;
    var timer$1 = setTimeout((function () {
            self.clickTimer = undefined;
            self.pushEvent(self.openEvent, {
                  id: self.itemId
                });
          }), 300);
    self.clickTimer = Caml_option.some(timer$1);
  };
  self.handleClick = onClick;
  element.addEventListener("click", onClick);
}

function updated() {
  var self = this ;
  var element = self.el;
  self.itemId = DomEl$GameDataCore.data(element, "item-id");
  self.openEvent = DomEl$GameDataCore.data(element, "open-event");
  self.toggleEvent = DomEl$GameDataCore.data(element, "toggle-event");
  syncSelectedBorder(element);
}

function destroyed() {
  var self = this ;
  var timer = self.clickTimer;
  if (timer !== undefined) {
    clearTimeout(Caml_option.valFromOption(timer));
  }
  self.el.removeEventListener("click", self.handleClick);
}

var selectableRow = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var dblclickWindowMs = 300;

export {
  dblclickWindowMs ,
  selectedBorderClass ,
  defaultBorderClass ,
  syncSelectedBorder ,
  mounted ,
  updated ,
  destroyed ,
  selectableRow ,
}
/* mounted Not a pure module */
